import React, { useState, useRef, useMemo, useEffect } from "react";
import { withRouter } from 'react-router-dom';
import JoditEditor from "jodit-react";
import './CreateDocument.scss';
import OpenNewWindowIcon from 'Components/icons/OpenNewWindowIcon/OpenNewWindowIcon.jsx';
import CreateDocumentSidePanel from './CreateDocumentSidePanel';
import { getCaseLandingData, getMerchantDetails } from 'Apis/caseManagerAPI.js';
import GDColorCodedCell from 'Components/GDTable/GDColorCodedCell/GDColorCodedCell';
import BookMarkIcon from 'Containers/Icon/BookMarkIcon/BookMarkIcon';
import { postBookMarkCase, undoBookMarkCase } from 'Apis/queueManagerApi.js';





export function openCaselanding(props) {
  window.open(`#/caselanding/${props.caseNumber}`);
}

export const CreateDocument = (props) => {
  window.document.title = props.caseNumber !== undefined ? 'Editor ' + props.caseNumber : 'Disputes Management';
  const editor = useRef(null)
  const [content, setContent] = useState('')
  const [caseLandingDetails, setCaseLandingDetails] = useState({});
  const [merchantDetails, setMerchantDetails] = useState({});
  const [isBookMarked, setIsBookMarked] = useState(false);

  useEffect(() => {
    getCaseLandingData(props.caseNumber)
      .then((apiResponse) => {
        setCaseLandingDetails(apiResponse.data);
        let disputeStageId = apiResponse.data.caseStageDetail.caseStageDetail_disputeStageId ? apiResponse.data.caseStageDetail.caseStageDetail_disputeStageId : apiResponse.data.caseStageDetail.disputeStageId ? apiResponse.data.caseStageDetail.disputeStageId : undefined;
        getMerchantDetails(props.caseNumber, disputeStageId)
          .then((merchantDetail) => {
            if (merchantDetail.data) {
              setMerchantDetails(merchantDetail.data);
            }
          })
        if (apiResponse.data.caseDetail.bookmarkBy !== undefined) {
          if (apiResponse.data.caseDetail.bookmarkBy) {
            setIsBookMarked(false);
          } else {
            setIsBookMarked(true);
          }
        }
      })
      .catch((error) => {
        setCaseLandingDetails([]);
      });
  }, [isBookMarked]);

  const toggleBookMarkIcon = () => {
    if (isBookMarked) {
      return postBookMarkCase(caseLandingDetails.caseStageDetail.caseStageId)
        .then(() => {
          setIsBookMarked(false);
        })
        .catch((error) => {
          console.log('Error Occured while Bookmarking the case', error);
        });
    }
    else {
      return undoBookMarkCase(caseLandingDetails.caseStageDetail.caseStageId)
        .then(() => {
          setIsBookMarked(true);
        })
        .catch((error) => {
          console.log('Error Occured while un-bookmarking the case', error);
        });
    }

  }



  const config = {

    imageDefaultWidth: 732,



    showPlaceholder: false,
    toolbar: true,
    uploader: { insertImageAsBase64URI: true },
    removeButtons: ['source', 'fullsize', 'about'],
    textIcons: false,
    toolbarSticky: true,
    useSearch: true,
    spellcheck: true,
    iframe: false,
    direction: 'auto',
    language: 'auto',
    preset: 'none',
    enter: 'P',
    defaultMode: '1',
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: true,
    theme: 'default',
    ColorBorder: 'auto',
    width: 'auto',
    minWidth: 200,
    defaultFontSizePoints: 'px',
    autofocus: true,
    inline: false,
    saveHeightInStorage: false,
    saveModeInStorage: false,
    readonly: false,
    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: 'insert_as_HTML',
    disablePlugins: ['powered-by-jodit', 'about', 'iframe', 'hr', 'link', 'media', 'video', 'file', 'print', 'image-properties'],
    buttons: ['undo', 'redo', 'preview', 'copyformat', , 'eraser', '|', 'font', 'fontsize', 'bold', 'italic', 'underline',
      'superscript', '|', 'ul', 'ol', 'indent', 'outdent', 'left', '|', 'image', 'table', 'symbol', '|', 'cut', 'copy',
      'paste', 'selectall', 'find', 'brush'],
    buttonsMD: ['undo', 'redo', 'preview', 'copyformat', 'eraser', '|'
      , 'font', 'fontsize', 'bold', 'italic', 'underline', 'superscript', '|',
      'ul', 'ol', 'indent', 'outdent', , , , , , , , , , , 'dots'],
    buttonsXS: ['undo', 'redo', 'preview', 'copyformat', 'eraser', '|'
      , 'font', 'fontsize', 'bold', 'italic', 'underline', 'superscript', '|',
      'ul', , , , , , , , , , 'dots'],
    buttonsSM: ['undo', 'redo', 'preview', 'copyformat', 'eraser', '|'
      , 'font', 'fontsize', 'bold', 'italic', 'underline', 'superscript', '|',
      'ul', , , , , , , , , , , 'dots'],
    toolbarAdaptive: 'adpative',
    style: {
      width: '82%',
      // margin: '0px 61px 0px 61px',
      marginLeft: '71px',
      marginTop: '21px',
      background: '#FFFFFF !important',
      boxShadow: '0px 7px 17px #D6DCE1, 0px 1px 5px #D6DCE1',
      border: 'default',
      panel: 'default',
      icon: 'default',
    },

    "minHeight": 563,
    "maxHeight": 563,
  }

  return (
    <div>
      <div className='main-content--header reports-container--header' style={{ zIndex: 2 }}>
        <span className="cases-number">
          <span className="bookmark-view" ><BookMarkIcon toggleBookMark={toggleBookMarkIcon} isBookMarked={!isBookMarked} height="20px" width="20px" /></span>
          {'Case #'}
          {props.caseNumber}
      &ensp;
        <span className="open-document" >
            <OpenNewWindowIcon
              onClick={() => { openCaselanding(props) }}
              height={13.5}
              width={18}
            />
          </span>
          <span className="merchant-name">
            {merchantDetails.dbaName && merchantDetails.dbaName.trim() != '0' ? merchantDetails.dbaName.trim() : ''}
            {merchantDetails.merchantNumber ? <span className="color-cell"><GDColorCodedCell content={`${merchantDetails.merchantNumber}`} /></span> : <span>--</span>}
          </span>
        </span>
      </div>
      <div>

        <div style={{ marginTop: '60px', width: '70%', float: 'left' }}>
          {useMemo(
            () => (
              <JoditEditor
                ref={editor}
                value={content}
                config={config}
                tabIndex={1} // tabIndex of textarea
                onBlur={newContent => setContent(newContent)}
                onChange={newContent => { }}
              />
            ),
            []
          )}
        </div>
        <CreateDocumentSidePanel
          caseNumber={props.caseNumber}
          content={content}
          caseLandingDetails={caseLandingDetails} />
      </div>
    </div>
  );
}

export default withRouter(CreateDocument);